export default __webpack_public_path__ + "static/lifecycle-light-d9d6cf102c5d03670559f59249d3aa6f.png";